import { formatDate } from '../../../core/helpers';
import { normalizeDateFE } from '../../../core/normalization';
import {
  PaymentConfirmationFile,
  SellerFilingReportToConfirm,
} from '../../../core/types';
import SellerFilingOngoingItem from './SellerFilingOngoingItem';
import { ReactComponent as FolderIcon } from '../../../icons/folder-green-xl.svg';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

interface Props {
  reports: SellerFilingReportToConfirm[];
  onFolderBtnClick: (
    files: PaymentConfirmationFile[],
    date: Date,
    comment?: string
  ) => () => void;
  onAmountBtnClick: (r: SellerFilingReportToConfirm) => () => void;
  onClickAgenda: (r: SellerFilingReportToConfirm) => () => void;
}

export default function SellerOngoingFiling({
  reports,
  onFolderBtnClick,
  onAmountBtnClick,
  onClickAgenda,
}: Props) {
  const { t } = useTranslation();

  return (
    <div>
      <div className='Text--20 fw-800 mb-3'>
        {formatDate(new Date(), 'MMMM yyyy')}
      </div>
      {reports.length ? (
        <>
          <div className='SellerFiling__alert px-2 py-1 mb-3 mt-n2'>
            <span>
              {t(
                'Please keep in mind that deadline is the date when VAT needs to be at foreign tax offices account already.'
              )}
            </span>
            &nbsp;
            <span
              dangerouslySetInnerHTML={{
                __html: `<span>${t(
                  'We recommend to transfer VAT payment at least *hours*'
                ).replace(
                  '*hours*',
                  `<span class='fw-600'>${t('48h before due date.')}</span>`
                )}</span>`,
              }}
            />
          </div>
          {reports
            .sort(
              (a, b) =>
                normalizeDateFE(
                  a.payment_instruction?.due_date || a.deadline_date
                ).getTime() -
                normalizeDateFE(
                  b.payment_instruction?.due_date || b.deadline_date
                ).getTime()
            )
            .map((r) => (
              <SellerFilingOngoingItem
                onClickAgenda={onClickAgenda(r)}
                report={r}
                key={uuidv4()}
                onFolderBtnClick={onFolderBtnClick(
                  r.confirmation?.documents || [],
                  normalizeDateFE(
                    r.payment_instruction?.due_date || r.deadline_date
                  ),
                  r.confirmation?.comment
                )}
                onBtnClick={onAmountBtnClick(r)}
              />
            ))}
        </>
      ) : (
        <div
          className='flex-grow-1 d-flex align-items-center justify-content-center flex-column'
          style={{
            minHeight: 500,
          }}
        >
          <FolderIcon />
          <div className='fw-800 multiline text-center mb-5'>
            {t("You don't have any ongoing filings this month")}
          </div>
        </div>
      )}
    </div>
  );
}
